"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Countdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../");
var Wrapper = (0, styled_components_1.default)(__1.Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 115px;\n  padding: 12px;\n  border-radius: 12px;\n\n  border: 1px solid ", ";\n\n  picture {\n    color: ", ";\n  }\n"], ["\n  width: 115px;\n  padding: 12px;\n  border-radius: 12px;\n\n  border: 1px solid ", ";\n\n  picture {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
});
var formatNumber = function (num) {
    if (Number.isNaN(num) || num <= 0) {
        return "00";
    }
    return "".concat(num).padStart(2, "0");
};
var getReturnValues = function (countDown) {
    var hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((countDown % (1000 * 60)) / 1000);
    return [formatNumber(hours), formatNumber(minutes), formatNumber(seconds)];
};
function useCountdown(targetDate, onCountdownEnd) {
    var countDownDate = new Date(targetDate).getTime();
    var _a = (0, react_1.useState)(countDownDate - new Date().getTime()), countDown = _a[0], setCountDown = _a[1];
    // to prevent infinite loop
    var countdownEndCb = (0, react_1.useRef)(onCountdownEnd);
    (0, react_1.useEffect)(function () {
        var _a;
        if (countDown <= 0) {
            (_a = countdownEndCb.current) === null || _a === void 0 ? void 0 : _a.call(countdownEndCb);
            return;
        }
        var interval = setInterval(function () {
            setCountDown(countDownDate - new Date().getTime());
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [countDownDate, countDown]);
    return getReturnValues(countDown);
}
var Countdown = function (_a) {
    var targetDate = _a.targetDate, onCountdownEnd = _a.onCountdownEnd;
    var _b = useCountdown(targetDate, onCountdownEnd), hours = _b[0], minutes = _b[1], seconds = _b[2];
    return ((0, jsx_runtime_1.jsx)(Wrapper, __assign({ "data-testid": "countdown-".concat(targetDate), "$alignItems": "center", "$justifyContent": "space-between" }, { children: (0, jsx_runtime_1.jsxs)(__1.Text, __assign({ family: "secondary", size: "sm" }, { children: [hours, ":", minutes, ":", seconds] })) })));
};
exports.Countdown = Countdown;
var templateObject_1;
